import React, { useEffect, useState } from "react";
import "./index.css";
import user from "../../assets/images/png/user.png";
import grafico from "../../assets/images/png/grafico.png";
import presente from "../../assets/images/png/presente.png";
import home from "../../assets/images/png/home.png";
import recibo from "../../assets/images/png/recibo.png";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import bola from "../../assets/images/png/bola.png";

// Componente de partículas de fogo
const FireParticles = ({ isActive }) => {
  const [particles, setParticles] = useState([]);
  const [smokeParticles, setSmokeParticles] = useState([]);

  useEffect(() => {
    if (!isActive) {
      setParticles([]);
      setSmokeParticles([]);
      return;
    }

    const createFireParticle = () => {
      return {
        id: Math.random(),
        x: 14 + (Math.random() - 0.5) * 8, // centro da bola com variação
        y: 14 + (Math.random() - 0.5) * 8,
        vx: (Math.random() - 0.5) * 3,
        vy: -Math.random() * 4 - 2,
        life: 1,
        decay: Math.random() * 0.015 + 0.008,
        size: Math.random() * 4 + 2,
        color: `hsl(${Math.random() * 20 + 15}, 100%, ${Math.random() * 20 + 60}%)`,
        type: 'fire'
      };
    };

    const createSmokeParticle = () => {
      return {
        id: Math.random(),
        x: 14 + (Math.random() - 0.5) * 6,
        y: 14 + (Math.random() - 0.5) * 6,
        vx: (Math.random() - 0.5) * 1.5,
        vy: -Math.random() * 2 - 1,
        life: 1,
        decay: Math.random() * 0.01 + 0.005,
        size: Math.random() * 6 + 3,
        color: `rgba(100, 100, 100, ${Math.random() * 0.3 + 0.2})`,
        type: 'smoke'
      };
    };

    const interval = setInterval(() => {
      setParticles(prev => {
        const newParticles = prev
          .map(p => ({
            ...p,
            x: p.x + p.vx,
            y: p.y + p.vy,
            life: p.life - p.decay,
            vy: p.vy + 0.15, // gravidade
            vx: p.vx * 0.98 // resistência do ar
          }))
          .filter(p => p.life > 0);

        if (newParticles.length < 6) {
          newParticles.push(createFireParticle());
        }

        return newParticles;
      });

      setSmokeParticles(prev => {
        const newSmoke = prev
          .map(p => ({
            ...p,
            x: p.x + p.vx,
            y: p.y + p.vy,
            life: p.life - p.decay,
            vy: p.vy + 0.1,
            vx: p.vx * 0.95,
            size: p.size + 0.1 // fumaça cresce
          }))
          .filter(p => p.life > 0);

        if (newSmoke.length < 4) {
          newSmoke.push(createSmokeParticle());
        }

        return newSmoke;
      });
    }, 50);

    return () => clearInterval(interval);
  }, [isActive]);

  if (!isActive) return null;

  return (
    <div className="fire-particles-container">
      {/* Partículas de fumaça */}
      {smokeParticles.map(particle => (
        <div
          key={`smoke-${particle.id}`}
          className="smoke-particle"
          style={{
            left: particle.x + 'px',
            top: particle.y + 'px',
            width: particle.size + 'px',
            height: particle.size + 'px',
            backgroundColor: particle.color,
            opacity: particle.life * 0.6,
            transform: `scale(${particle.life * 1.5})`
          }}
        />
      ))}
      
      {/* Partículas de fogo */}
      {particles.map(particle => (
        <div
          key={`fire-${particle.id}`}
          className="fire-particle"
          style={{
            left: particle.x + 'px',
            top: particle.y + 'px',
            width: particle.size + 'px',
            height: particle.size + 'px',
            backgroundColor: particle.color,
            opacity: particle.life,
            transform: `scale(${particle.life})`,
            boxShadow: `0 0 ${particle.size * 2}px ${particle.color}`
          }}
        />
      ))}
    </div>
  );
};

export default function Footer() {
  const locate = useLocation();
  const url = locate.pathname;
  const isBolaActive = url.includes("ranking-libertadores");

  return (
    <>
      <div className="d-flex justify-content-center">
        <div className="divFooterExterna">
          <div className="divFooter">
            <Link
              to={"/catalogo"}
              className={url.includes("catalogo") ? "menuAtivo" : "menuInativo"}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16.86"
                height="16.86"
                viewBox="0 0 16.86 16.86"
              >
                <path
                  id="Caminho_7911"
                  data-name="Caminho 7911"
                  d="M115.182,47.933a2.676,2.676,0,0,0-2.573-2.667,2.658,2.658,0,0,0,.274-1.16,2.686,2.686,0,0,0-2.682-2.682,3.95,3.95,0,0,0-3.449,2.406,3.949,3.949,0,0,0-3.449-2.406,2.686,2.686,0,0,0-2.682,2.682,2.647,2.647,0,0,0,.275,1.16,2.671,2.671,0,0,0-1.041,5.086v4.992a2.942,2.942,0,0,0,2.938,2.939h7.917a2.942,2.942,0,0,0,2.939-2.939V50.353A2.682,2.682,0,0,0,115.182,47.933ZM110.2,42.957a1.15,1.15,0,0,1,0,2.3h-2.417C108.144,44.3,108.888,42.957,110.2,42.957Zm-6.9,0c1.313,0,2.057,1.348,2.418,2.3H103.3a1.15,1.15,0,0,1,0-2.3ZM101,46.788h4.986v2.3H101a1.15,1.15,0,0,1,0-2.3Zm.388,8.556V50.62h4.6v6.131h-3.193A1.408,1.408,0,0,1,101.387,55.345Zm9.323,1.406h-3.192V50.62h4.6v4.725A1.408,1.408,0,0,1,110.71,56.751Zm1.793-7.664h-4.985v-2.3H112.5a1.15,1.15,0,0,1,0,2.3Z"
                  transform="translate(-98.322 -41.424)"
                  fill={url.includes("catalogo") ? "#000000" : "#cfdcdf"}
                />
              </svg>
            </Link>
            <Link
              to={"/home"}
              className={url.includes("home") ? "menuAtivo" : "menuInativo"}
            >
              <div>
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.36365 7.61377H18.6364C19.6029 7.61377 20.3864 8.39727 20.3864 9.36377V18.6365C20.3864 19.603 19.6029 20.3865 18.6364 20.3865H9.36365C8.39715 20.3865 7.61365 19.603 7.61365 18.6365V9.36377C7.61365 8.39727 8.39715 7.61377 9.36365 7.61377Z"
                    stroke={url.includes("home") ? "#000000" : "#cfdcdf"}
                    strokeWidth="2.5"
                  />
                  <circle
                    cx="14"
                    cy="14"
                    r="12.75"
                    stroke={url.includes("home") ? "#000000" : "#cfdcdf"}
                    strokeWidth="2.5"
                  />
                </svg>
              </div>
            </Link>
            <Link
              to={"/ranking-libertadores"}
              className={
                url.includes("ranking-libertadores")
                  ? "menuAtivo"
                  : "menuInativo"
              }
            >
              <div className="bola-container">
                <img width={28} src={bola} alt="Bola" />
                <FireParticles isActive={isBolaActive} />
              </div>
            </Link>
            <Link
              to={"/meu-cadastro"}
              className={
                url.includes("meu-cadastro") ? "menuAtivo" : "menuInativo"
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17.327"
                height="19.059"
                viewBox="0 0 17.327 19.059"
              >
                <g
                  id="Grupo_4134"
                  data-name="Grupo 4134"
                  transform="translate(1.121 1.1)"
                >
                  <g
                    id="Grupo_4125"
                    data-name="Grupo_4125"
                    transform="translate(0 0)"
                  >
                    <path
                      id="Caminho_1955"
                      data-name="Caminho 1955"
                      d="M18.206,5.715A4.215,4.215,0,1,1,13.991,1.5,4.215,4.215,0,0,1,18.206,5.715Z"
                      transform="translate(-6.448 -1.5)"
                      fill="none"
                      stroke={
                        url.includes("meu-cadastro") ? "#000000" : "#cfdcdf"
                      }
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2.2"
                    />
                    <path
                      id="Caminho_1956"
                      data-name="Caminho_1956"
                      d="M14.855,32.734a1.713,1.713,0,0,0,1.583-2.388,8.095,8.095,0,0,0-14.792,0,1.713,1.713,0,0,0,1.583,2.388Z"
                      transform="translate(-1.5 -15.874)"
                      fill="none"
                      stroke={
                        url.includes("meu-cadastro") ? "#000000" : "#cfdcdf"
                      }
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2.2"
                    />
                  </g>
                </g>
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
